// extracted by mini-css-extract-plugin
module.exports = {"menuText":"#333","menuActiveText":"#fff","subMenuActiveText":"#0b62e5","menuBg":"transparent","menuHover":"#fff","subMenuBg":"#020202","subMenuHover":"#fff","sideBarWidth":"240px"};